import { connect } from 'react-redux'
import LessonList from './component'

import NavigationHelper from 'layers/navigation/navigationHelper'

export default connect(null, NavigationHelper.mapDispatchToProps)(LessonList)
